module.exports = __webpack_public_path__ + "static/img/u70040.4ed76cfc.png";